import React from 'react';
import { HashDialog } from '../../../../shared/components/dialog/HashDialog';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { ModifyGuestBookingDialog } from './ModifyGuestBookingDialog';

export const PARKING_MODIFY_GUEST_BOOKING_HASH_PATTERN =
	'#modify-guest-booking';

export const ModifyGuestBookingDialogRoute = () => {
	const { t } = useTranslation();

	return (
		<HashDialog
			hash={PARKING_MODIFY_GUEST_BOOKING_HASH_PATTERN}
			ariaLabel={t('parking_modify_guest_booking_dialog_header')}
		>
			<ModifyGuestBookingDialog />
		</HashDialog>
	);
};
